<template>
    <div class="social-sharing">
      <div class="preamble">Share this article:</div>
      <div class="share-bnts">
        <ShareNetwork
          network="facebook"
          :url="this.shareUrl"
          :title="'FAQ: ' + faqArticle.title"
          :description="faqArticle.desc"
        >
          <div class="icon -facebook"></div>
        </ShareNetwork>

        <ShareNetwork
          network="twitter"
          :url="this.shareUrl"
          :title="faqArticle.title"
        >
          <div class="icon -twitter"></div>
        </ShareNetwork>

        <div class="share-network-link">
          <v-tooltip
            top
            :open-on-hover="false"
            :open-on-click="false"
            :open-on-focus="false"
            v-model="tooltip"
          >
            <template v-slot:activator="{}">
              <div
                class="icon -link clip-copy"
                @click="copyToClip"
              ></div>
            </template>
            <span>Copied</span>
          </v-tooltip>
        </div>
      </div>
    </div>
</template>
<script>
export default {
  name: 'SocialShare',
  props: {
    faqArticle: Object,
    articleDir: Object,
  },
  data() {
    return {
      shareUrl: '',
      domain: 'healthnow.ph',
      tooltip: false,
    };
  },
  mounted() {
    this.setUpLink();
  },
  updated() {
    this.setUpLink();
  },
  methods: {
    closeTooltip() {
      this.tooltip = false;
    },
    copyToClip(event) {
      const urlCont = document.createElement('textarea');
      const button = event.target;

      button.appendChild(urlCont);

      urlCont.value = this.shareUrl;
      urlCont.select();

      try {
        document.execCommand('copy');
        console.log('Copied Link');

        this.tooltip = true;
        setInterval(this.closeTooltip, 800);
      } catch (err) {
        console.log('Error in copying the link');
      }

      button.removeChild(urlCont);
    },
    setUpLink() {
      this.domain = window.location.origin;
      this.shareUrl = `${this.domain}/frequently-asked-questions/${this.articleDir.tab}/${this.articleDir.article}`;
    },
  },
};
</script>
